import { auth } from './firebase';
import { startArtifactDownload } from '../utils/artifactDownload';

export const downloadDiligenceArtifact = async (chatId: string, artifactId: string, _fileName: string) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Debes iniciar sesión para descargar el documento.');
  const token = await user.getIdToken();
  const params = new URLSearchParams({ chatId, artifactId });
  const response = await fetch(`/api/diligence-artifacts?${params}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!response.ok) throw new Error('No se pudo preparar la descarga.');
  const result = await response.json() as { downloadUrl: string };
  startArtifactDownload(result.downloadUrl);
};
